import { FC } from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';
import { useMediaQuery } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { numberLocalization } from 'src/helpers/numberLocalization';

interface Props {
  label: string;
  percent: number;
  value?: number;
  className?: string;
  deviceWidth?: number;
  mobileWidth?: number;
  isPercent?: boolean;
  color?:string
}

const LineProgress: FC<Props> = ({
  label,
  percent,
  value,
  className,
  mobileWidth = 120,
  deviceWidth = 220,
  isPercent = true,
  color
}: Props): JSX.Element => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isExtraLargeDevice = useMediaQuery('(max-width: 1408px)');
  const progressBarWidth = Math.round(
    (((isMobile && mobileWidth) || (isExtraLargeDevice && 180) || deviceWidth) * percent) / 100,
  );
  const [t] = useTranslation('reported');
  return (
    <div className={classNames(styles.line_progress_container, className)}>
      <label className={styles.label}>{label}</label>
      <div className={styles.progressWrapper}>

        {isPercent ? (
          <progress
            style={{ minWidth: progressBarWidth, maxWidth: progressBarWidth}}
            value={percent}
            max={100}
            
            className={styles.progress}
            aria-valuenow={percent}
            aria-valuemin={0}
            aria-valuemax={100}
            tabIndex={0}
            role={'progressbar'}
            aria-label={label}></progress>
        ) : (
          <progress
            style={{ minWidth: progressBarWidth, maxWidth: progressBarWidth   }}
            tabIndex={0}
            role={'progressbar'}
            aria-label={`${label} ${t('progressBarIssues', { value })}`}></progress>
        )}
        <div className={styles.overlay} aria-hidden style={{ width: progressBarWidth  ,  backgroundColor : color ?? "#264547" }}></div>
      </div>
      <span className={styles.percent}>{value ? numberLocalization(value) : percent}</span>
    </div>
  );
};

export default LineProgress;
